import $api from "@/zapi-admin/shared/api/axios";
import { downloadBlob } from "@/zapi-admin/shared/lib/dowload";
import {
  ClaudeRunDetailsSchema,
  ClaudeRunSchema,
  ClaudeRunsFiltersSchema,
  ClaudeRunsListSchema,
  type TClaudeRunsQuery
} from "./types";

const BASE = "/admin/claude-runs";

export const fetchClaudeRuns = async (query: TClaudeRunsQuery, page: number, pageSize: number) => {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  for (const [key, value] of Object.entries(query)) {
    if (value) params.set(key, value);
  }
  const response = await $api.get(`${BASE}?${params.toString()}`);
  return ClaudeRunsListSchema.parse(response.data.data);
};

export const fetchClaudeRunFilters = async () => {
  const response = await $api.get(`${BASE}/filters`);
  return ClaudeRunsFiltersSchema.parse(response.data.data);
};

export const fetchClaudeRun = async (id: string) => {
  const response = await $api.get(`${BASE}/${id}`);
  return ClaudeRunDetailsSchema.parse(response.data.data);
};

// The raw file text: axios must not try to parse a one-line JSON file into an object.
export const fetchClaudeRunFile = async (id: string, name: string) => {
  const response = await $api.get<string>(`${BASE}/${id}/file`, {
    params: { name },
    responseType: "text",
    transformResponse: [(data: string) => data]
  });
  return response.data;
};

export const downloadClaudeRunZip = async (id: string) => {
  const response = await $api.get<Blob>(`${BASE}/${id}/download`, { responseType: "blob" });
  downloadBlob(response.data, `claude-run-${id}.zip`);
};

export const collectClaudeRunLogs = async (id: string) => {
  const response = await $api.post(`${BASE}/${id}/collect-logs`);
  return ClaudeRunSchema.parse(response.data.data);
};
